<div class="coming">
  <div class="wrapper">
    <img src="assets/images/Coming-Soon.png" alt="coming-soon" />
    <p class="label">Coming Soon!</p>
    <p class="note">We are currently working to launch this feature soon.</p>
  </div>
</div>
